module.exports = __webpack_public_path__ + "static/incorrect-5f26da628c7f66b4aae097e1962b9dd1.png";